// src/components/OrderCard.js
import React from "react";
import { formatDate } from "../utils/format";

export default function OrderCard({ order, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: "#fff",
        padding: 20,
        borderRadius: 12,
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        width: 280,
        cursor: "pointer",
      }}
    >
      <h3 style={{ margin: 0 }}>
        Pedido #{order.DocNum}
        {order.NumAtCard ? ` – [${order.NumAtCard}]` : ""}
      </h3>
      <p>
        Cliente: <b>{order.Razon_Social}</b>
      </p>
      <p>
        Estatus: <b>{order.Estatus}</b>
      </p>
      <hr />
      <p>
        📦{" "}
        <b>
          {order.pick_count > 0 ? `[${order.pick_count}]` : ""} Último picking:
        </b>{" "}
        {formatDate(order.last_pick)}
      </p>
      <p>
        ✅{" "}
        <b>
          {order.dln_count > 0 ? `[${order.dln_count}]` : ""} Última entrega:
        </b>{" "}
        {formatDate(order.last_dln)}
      </p>
      <p>
        ⏱️ <b>Lead Time:</b>{" "}
        {order.leadTime != null ? `${order.leadTime} días` : "-"}
      </p>
      <p>
        📊 <b>Avance:</b> {order.progress ?? 0}%
      </p>
    </div>
  );
}
